
  import { Component, Prop, Vue } from 'vue-property-decorator';
  import Proxyable from 'vuetify/lib/mixins/proxyable'

  @Component({
    mixins: [Proxyable],
  })
  export default class MaterialTabs extends Vue {
    @Prop({ type: String, default: 'primary' }) private readonly color!: string
  }
